import api from '../api'

const baseUrl = '/academy/api/Basket'

const dadbanOrderProvider = {
  downloadExcel() {
    return api.get(`${baseUrl}/Download`)
  },
  fetchOrderItems(params) {
    return api.post(`${baseUrl}/AdminOrderItem`, params)
  },
  cancelOrderItem(params) {
    return api.post(`${baseUrl}/CancelOrder`, params)
  },
  cancelOrder(params) {
    return api.put(`/academy/api/AdminCourse/CancelOrder`, params)
  },
  cancelBasket(orderId) {
    return api.get(`/academy/api/Basket/TestSnapPayCancel/${orderId}`)
  },
}

export default dadbanOrderProvider
